export const thfModalPasswordRecoveryLiterals = {
  en: <any> {
    cancelButton: 'Cancel',
    closeButton: 'Close',
    continueButton: 'Continue',
    email: 'e-mail',
    emailErrorMessagePhrase: 'Invalid e-mail format',
    emailSentConfirmationPhrase: `We have sent the instructions and new password creation link to your e-mail.
    If you did not receive it after a few minutes, check your spam box or click Resend.`,
    emailSentTitle: 'E-mail sent',
    forgotPasswordTitle: 'Forgot your password?',
    insertCode: 'Type the code',
    insertEmail: 'Enter your e-mail',
    insertPhone: 'Enter your mobile number',
    phoneErrorMessagePhrase: 'Invalid phone number',
    prepositionIn: 'in',
    prepositionOr: 'or',
    recoveryPasswordPhrase: 'To recover your password we will send you a {0} with instructions.',
    resendEmailButton: 'Resend',
    resendSmsCodePhrase: 'If the code does not arrive within a few minutes, please send it again.',
    sendAgainPhrase: 'If the code does not arrive within a few minutes',
    sendAgain: 'send again.',
    sendButton: 'Submit',
    sentSmsCodePhrase: 'We sent a code for your mobile phone.',
    sms: 'SMS',
    smsCodeErrorMessagePhrase: 'Invalid code. Please re-enter or contact support',
    supportContact: 'If you do not have access to {0} contact support',
    telephone: 'telephone',
    typeCodeTitle: 'Enter sent code'
  },
  es: <any> {
    cancelButton: 'Cancelar',
    closeButton: 'Cerrar',
    continueButton: 'Continuar',
    email: 'e-mail',
    emailErrorMessagePhrase: 'Formato de correo electrÃ³nico no vÃ¡lido',
    emailSentConfirmationPhrase: `Enviamos las instrucciones y enlace de creaciÃ³n de nueva contraseÃ±a para su correo electrÃ³nico.
    Si no ha recibido despuÃ©s de unos minutos, compruebe su caja de spam o haga clic en Reenviar`,
    emailSentTitle: 'E-mail enviado',
    forgotPasswordTitle: 'Olvidaste tu contraseÃ±a?',
    insertCode: 'Introduzca el cÃ³digo',
    insertEmail: 'Introduce tu e-mail',
    insertPhone: 'Introduce tu nÃºmero de celular',
    phoneErrorMessagePhrase: 'NÃºmero de telÃ©fono no vÃ¡lido',
    prepositionIn: 'en',
    prepositionOr: 'u',
    recoveryPasswordPhrase: 'Para recuperar su contraseÃ±a vamos a enviar un {0} con instrucciones.',
    resendEmailButton: 'Reenviar',
    resendSmsCodePhrase: 'Si el cÃ³digo no llega dentro de unos minutos, vuelva a enviar.',
    sendAgain: 'envÃ­e de nuevo.',
    sendAgainPhrase: 'Si el cÃ³digo no llega dentro de unos minutos',
    sendButton: 'Enviar',
    sentSmsCodePhrase: 'Enviamos un cÃ³digo para su celular.',
    sms: 'SMS',
    smsCodeErrorMessagePhrase: 'CÃ³digo no vÃ¡lido. Escriba de nuevo o pÃ³ngase en contacto con el soporte',
    supportContact: 'Si no tiene acceso a {0} pÃ³ngase en contacto con el soporte',
    telephone: 'telÃ©fono',
    typeCodeTitle: 'Escribir cÃ³digo enviado'
  },
  pt: <any> {
    cancelButton: 'Cancelar',
    closeButton: 'Fechar',
    continueButton: 'Continuar',
    email: 'e-mail',
    emailErrorMessagePhrase: 'Formato de e-mail invÃ¡lido',
    emailSentConfirmationPhrase: `Enviamos as instruÃ§Ãµes e link de criaÃ§Ã£o de nova senha para o seu e-mail.
    Caso nÃ£o tenha recebido apÃ³s alguns minutos, verifique sua caixa de spam ou clique em Reenviar.`,
    emailSentTitle: 'E-mail enviado',
    forgotPasswordTitle: 'Esqueceu sua senha?',
    insertCode: 'Digite o cÃ³digo',
    insertEmail: 'Insira seu e-mail',
    insertPhone: 'Insira seu nÃºmero de celular',
    phoneErrorMessagePhrase: 'NÃºmero de telefone invÃ¡lido',
    prepositionIn: 'em',
    prepositionOr: 'ou',
    recoveryPasswordPhrase: 'Para recuperar sua senha vamos enviar um {0} com instruÃ§Ãµes.',
    resendEmailButton: 'Reenviar',
    resendSmsCodePhrase: 'Se o cÃ³digo nÃ£o chegar dentro de alguns minutos envie novamente',
    sendAgain: 'envie novamente.',
    sendAgainPhrase: 'Se o cÃ³digo nÃ£o chegar dentro de alguns minutos',
    sendButton: 'Enviar',
    sentSmsCodePhrase: 'Enviamos um cÃ³digo para seu celular cadastrado.',
    sms: 'SMS',
    smsCodeErrorMessagePhrase: 'CÃ³digo invÃ¡lido. Digite novamente ou contacte o suporte',
    supportContact: 'Se nÃ£o tiver acesso ao {0} contacte o suporte',
    telephone: 'telefone',
    typeCodeTitle: 'Digitar cÃ³digo enviado'
  }
};
